/**
 * Lightweight dev-only logger. Emits to console in non-production builds
 * (CRA sets NODE_ENV automatically) and no-ops in production.
 *
 * Use in catch blocks and non-critical paths where a hard console.warn would
 * spam production but we still want observability in local + preview.
 */
const isProd = typeof process !== "undefined" && process.env && process.env.NODE_ENV === "production";

export const devWarn = (...args) => { if (!isProd) console.warn(...args); };
export const devError = (...args) => { if (!isProd) console.error(...args); };
